export default "__VITE_ASSET__1ba66f8d__"